module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarmsSandwichboardsignfinished2019.db657106.webp";